<template>
    <div class="card-base d-flex flex-column px-2 px-md-4 mb-5 mb-lg-0">
        <div class="card-base-header d-flex mx-auto">
            <img v-if="post.src"
                 :src="require(`@/assets/partner/${post.src}`)"
                 :alt="post.name"
                 class="img-fluid m-auto"
            >
        </div>
        <div class="card-base-body d-flex my-4 pb-2">
            <div class="fs-b fw-4 text-center" :class="['fs-m', tclass]">
                {{objData}}
            </div>
        </div>
        <div class="card-base-footer d-flex mt-auto">
            <a class="link _dodge ff-m fw-7 text-start mx-auto" :href="post.url" target="_blank">
                <svg class="icon me-2" viewBox="0 0 24 24">
                    <use xlink:href='#icon-web' x="0" y="0"/>
                </svg>
                <span>Перейти на сайт</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardBase",
        props: {
            post: {
                type: Array,
                default() {
                    return [{
                        id: 0,
                        date: '',
                        src: '',
                        url: '',
                        name: '',
                        data: [],
                    }]
                }
            },
            tclass: {
                type: String,
                default: '',
            }
        },
        computed: {
            objData: function () {
                return this.post.data[0];
            },
        },
    }
</script>

<style lang="scss" scoped>
    .card-base {
        @include _992 {
            height: 100%;
        }

        &-header {
            height: 84px;
        }
    }
</style>